export default function flatten2dArray(array) {
    return [].concat(...array);
}
